// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled product section
export const ProductFormContainer = styled.form`
    /* Appearance */
    background-color: white;
    border-radius: 10px;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;

    /* Size */
    width: 90%;
    max-width: 1200px;

    /* Spacing */
    padding: 50px;
    gap: 30px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.5);

    /* Mobile setup */
    @media (max-width: 600px) {
        width: 85vw;
        gap: 7px;

        padding: 15px;
    }
`;

// Styled product title
export const ProductTitleEditor = styled.textarea`
    /* Appearance */
    border: solid 1px;
    text-align: center;
    font-weight: bold;
    font-size: 1.5rem;

    /* Size */
    width: 50%;
    resize: vertical;

    /* Mobile setup */
    @media (max-width: 600px) {
        font-size: 1.3rem;

        width: 75%;
    }
`;

// Styled product description
export const ProductDescriptionEditor = styled.textarea`
    /* Appearance */
    border: solid 1px;

    /* Size */
    width: calc(100% - 100px);
    resize: vertical;

    /* Spacing */
    margin-left: 50px;
    margin-right: 50px;

    /* Mobile setup */
    @media (max-width: 600px) {
        width: calc(100% - 25px);

        margin-left: 3vw;
        margin-right: 3vw;
    }
`;

// Styled product price div
export const ProductPriceDiv = styled.div`
    /* Content disposition */
    display: flex;
    justify-content: space-between;

    /* Size */
    width: calc(100% - 100px);

    /* Spacing */
    margin-right: 50px;
    margin-left: 50px;

    /* Mobile setup */
    @media (max-width: 600px) {
        width: calc(100% - 25px);

        margin-left: 3vw;
        margin-right: 3vw;
    }
`;

// Subsection for product price div to allow
// to place rignt and left fields
export const ProductPriceSubDiv = styled.div.withConfig({
    shouldForwardProp: (prop) => !['left', 'right'].includes(prop),
})`
    /* Content disposition */
    display: flex;
    ${(props) => props.left && 'justify-content: flex-start;'}
    ${(props) => props.right && 'justify-content: flex-end;'}

    /* Size */
    width: 40%;

    /* Mobile setup */
    @media (max-width: 600px) {
        width: 50%;
    }
`;

// Styled product price
export const ProductPriceEditor = styled.input`
    /* Appearance */
    border: solid 1px;
    text-align: right;

    /* Size */
    width: 75%;
`;

// Checkbox for offer boolean
export const ProductOfferCheckbox = styled.input``;

// Styled section for the button
export const ButtonSection = styled.section`
    /* Content disposition */
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    /* Element disposition */
    align-self: flex-end;

    /* Spacing */
    margin-left: auto;
    margin-right: 2vw;

    /* Mobile setup */
    @media (max-width: 600px) {
        margin-right: 3vw;
    }
`;

// Update buttons
export const EditButton = styled.button`
    align-self: flex-end;

    /* Spacing */
    margin-left: auto;
    margin-right: 2vw;

    /* Events */
    cursor: pointer;

    /* Mobile setup */
    @media (max-width: 600px) {
        margin-right: 3vw;
    }
`;

// Styled submit button
export const SubmitButton = styled.button`
    /* Appearance */
    background-color: ${colors.primaryBeige};
    border-radius: 10px;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Spacing */
    padding: 5px 10px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);

    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }
`;

// Styled delete button
export const DeleteButton = styled.button`
    /* Appearance */
    background-color: ${colors.secondaryRed};
    border-radius: 10px;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Spacing */
    padding: 5px 10px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);

    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }
`;

// Settings Icon
export const Icon = styled.svg`
    /* Appearance */
    fill: ${colors.primaryBeige};

    /* Size */
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;

    &:hover {
        filter: brightness(1.2);
    }
`;
